import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { CustomAccordion, Text } from '../../shared/uiComponents';
import { Loader, InfoRow as Row } from '../StyledComponents';

import { DispatchProperties, useSelector } from '../../redux/store';
import { getBCBAClinicalSupervisors } from '../../redux/State/userSlice';

const SupervisorList = ({ userId }: { userId: string }) => {
	const dispatch = useDispatch<DispatchProperties>();

	const clinicalSupervisors = useSelector((state) => state.clinicalSupervisor.bcbasClinicalSupervisors);
	const loading = useSelector((state) => state.clinicalSupervisor.loading);

	useEffect(() => {
		if (!userId) return;
		dispatch(getBCBAClinicalSupervisors(userId));
	}, [dispatch, userId]);

	return (
		<CustomAccordion
			headerStyle={{ padding: 0 }}
			HeaderContent={() => (
				<Row>
					<Text title="Clinical Supervisor Assigned: " type="psm" fontWeight="semiBold" />
					<Text type="psm" title={`${clinicalSupervisors.length ? clinicalSupervisors.length : 0}`} />
				</Row>
			)}
			Content={() => (
				<div style={{ padding: '0px 8px' }}>
					{clinicalSupervisors?.length ? (
						<>
							{clinicalSupervisors.map((user, index) => (
								<Text key={index} title={`${index + 1}. ${user.fullName}`} type="psm" />
							))}
						</>
					) : (
						<Text title="None" type="psm" />
					)}
					{loading && <Loader />}
				</div>
			)}
		/>
	);
};

export default SupervisorList;
